import { environment } from '../environments/environment';

export function shouldRegisterServiceWorker(forceProduction = environment.production): boolean {
  if (!forceProduction) {
    return false;
  }

  const hostname = globalThis.location?.hostname?.toLowerCase() ?? '';
  const localHosts = ['localhost', '127.0.0.1', '0.0.0.0', '[::1]'];

  return !localHosts.includes(hostname);
}
